import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/cal-diy/apps/web/components/PageWrapperAppDir.tsx");
;
import(/* webpackMode: "eager" */ "/opt/cal-diy/node_modules/next/dist/client/script.js");
